import loadable from '@loadable/component';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import APIS from '../../constant/Endpoint';
import useGetHook from '../../customHooks/useGetHook';
const QuickSmsComponent = loadable(
  () => import('../../components/QuickSms/QuickSms')
);
const QuickSms = () => {
  const { refetch } = useGetHook({
    url: APIS.SENDER_SMS,
    queryKey: ['contacts'],
    params: {
      is_default: true,
    },
  });
  return (
    <>
      <div className={tw`pb-2`}>
        <h1 className={tw`text-lg font-semibold`}> Quick SMS</h1>
      </div>
      <QuickSmsComponent refetch={refetch} />
    </>
  );
};

export default QuickSms;
